import { isObject, isString } from '@app/typeGuards'

import { isNull } from '@app/utils/isNull'
import { isEmptyString } from '@app/utils/isEmptyString'
import { isNullable } from '@app/utils/isNullable'

import type { To } from 'react-router-dom'

const buildSearchParamsFromSavedKeys = (
  searchParams: URLSearchParams,
  sharedSearchParamKeys: string[]
): string | undefined => {
  let searchParamsString = ''

  sharedSearchParamKeys.forEach(key => {
    const value = searchParams.get(key)

    if (!isNull(value)) {
      if (isEmptyString(searchParamsString)) {
        searchParamsString += '?'
      } else {
        searchParamsString += '&'
      }

      searchParamsString += `${key}=${value}`
    }
  })

  return isEmptyString(searchParamsString) ? undefined : searchParamsString
}

const mergeSearchParams = (root: string, additional?: string): string => {
  if (additional === undefined) return root

  return root + '&' + additional.slice(1)
}

const buildToDestination = (to: To, searchParams: URLSearchParams, sharedSearchParamkeys: string[]): To => {
  const searchParamsString = buildSearchParamsFromSavedKeys(searchParams, sharedSearchParamkeys)

  if (isString(to) && !isNullable(searchParamsString)) {
    return to + searchParamsString
  }

  if (isObject(to) && !isNullable(searchParamsString)) {
    const { search } = to
    const mergedSearchParams = mergeSearchParams(searchParamsString, search)

    return { ...to, search: mergedSearchParams }
  }

  return to
}

export default buildToDestination
